import { useEffect, useState } from 'react'
import { useLocale } from '@hooks/useLocale'
import { getLanguageAndCountry } from '@utils/quiz'
import { featureFlags, isFeatureEnabled } from '@featureflags'
import { AdobeAnalyticsProvider } from '@hooks/useAdobeAnalytics'
import { useLocation } from 'react-use'

const AdobeAnalytics = ({ children, siteSection = '' }) => {
  const locale = useLocale()
  const location = useLocation()
  const [pageEventFired, setPageEventFired] = useState(false)

  const waData = {
    appId: 'fe0ee5f9-e54c-4bc7-8234-d995f88c6ae4',
    siteName: 'assassins creed : quiz',
    siteType: 'quiz',
    environment: 'prod',
    country: getLanguageAndCountry(locale).country,
    language: getLanguageAndCountry(locale).language,
    mdmBrandId: '',
    mdmInstallmentId: '',
    game: '',
    brand: 'Assassins Creed',
    campaignType: null,
    enablePerformance: null,
  }

  const handleAnalytics = (e) => {
    if (e.data == 'ANALYTICS_SDK_LOADED') {
      window.adobeAnalytics.init(waData)
    }
    if (e.data == 'S_CODE_READY' || e.data == 'PRIVACY_POLICY_ACCEPTED') {
      window.adobeAnalytics.track('pageevent', {
        pageName: 'main',
        pageUrl: location?.href,
        siteSection: siteSection,
      })
    }
    if (e.data == 'PAGEVIEW_EVENT_FIRED') {
      setPageEventFired(true)
    }
  }

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      !isFeatureEnabled(featureFlags.ADOBE_ANALYTICS)
    )
      return

    window.addEventListener('message', handleAnalytics, false)

    const script = document.createElement('script')
    script.src =
      'https://ubistatic-a.ubisoft.com/0106/prod/global/tracking/analyticssdk.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      window.removeEventListener('message', handleAnalytics, false)
      document.body.removeChild(script)
    }
  }, [])

  return (
    <AdobeAnalyticsProvider isSdkReady={pageEventFired}>
      {children}
    </AdobeAnalyticsProvider>
  )
}

export default AdobeAnalytics
